import classNames from 'classnames'

import { LoadingStatus, StatusWidgetContainer } from '@apps-common/apps/portal/pages/units/pages/manage/components'
import { BiNoSignal, BiSignal1, BiSignal2, BiSignal3, BiSignal4, BiSignal5 } from 'react-icons/bi'

const SIGNAL_ICON_CLASSES = 'text-[24px] sm:text-[27px]'

interface IProps {
  loading: boolean
  data: number | undefined
  classes?: string
}

export const SignalStatus = ({ loading, data, classes }: IProps) => {
  const FullIcon = BiSignal5
  const HiIcon = BiSignal4
  const MedIcon = BiSignal3
  const LowIcon = BiSignal2
  const VeryLowIcon = BiSignal1
  const NoneIcon = BiNoSignal

  if (loading) {
    return <LoadingStatus />
  }

  return (
    <StatusWidgetContainer>
      <div
        className={classNames(
          classes,
          'text-text-muted text-center px-[6px] py-[4px] rounded-[14px] flex flex-col items-center justify-between gap-[2px] h-[50px] sm:h-[60px] w-[58px]'
        )}
      >
        <div className='relative grow px-[3px] rounded-[5px] sm:pt-[2px] flex items-center justify-center'>
          {(!data || data <= 0) && <NoneIcon className={classNames(SIGNAL_ICON_CLASSES)} />}
          {data && data > 0 && <FullIcon className={classNames(SIGNAL_ICON_CLASSES, 'absolute opacity-10')} />}
          {data && data >= 1 && data < 3 && <VeryLowIcon className={classNames(SIGNAL_ICON_CLASSES)} />}
          {data && data >= 3 && data < 5 && <LowIcon className={classNames(SIGNAL_ICON_CLASSES)} />}
          {data && data >= 5 && data < 7 && <MedIcon className={classNames(SIGNAL_ICON_CLASSES)} />}
          {data && data >= 7 && data < 9 && <HiIcon className={classNames(SIGNAL_ICON_CLASSES)} />}
          {data && data >= 9 && <FullIcon className={classNames(SIGNAL_ICON_CLASSES)} />}
        </div>
        <div className='uppercase jost-medium text-[9px] sm:text-[9px] sm:pb-[3px]'>Signal</div>
      </div>
    </StatusWidgetContainer>
  )
}
